import type { PageTab } from '@mdvip/shared/components/shared/PageTabs';
import { PageTabPanel, PageTabs } from '@mdvip/shared/components/shared/PageTabs';
import { useTranslation } from 'react-i18next';

import { Navigation } from '@/components/Navigation';

import { PastTransactionsPage } from './PastTransactionsPage';
import { PaymentAccountsPage } from './PaymentAccountsPage';
import { PaymentCenterPage } from './PaymentCenterPage';

export function PaymentsPage() {
  const { t } = useTranslation('members');

  const tabs: PageTab[] = [
    { value: 'payment-center', label: t('payments.tabs.paymentCenter') },
    { value: 'payment-accounts', label: t('payments.tabs.paymentAccounts') },
    { value: 'past-transactions', label: t('payments.tabs.pastTransactions') },
  ];

  return (
    <div className="min-h-screen bg-background pb-20 md:pb-6">
      <Navigation />
      <main className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">{t('payments.title')}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t('payments.subtitle')}</p>
        </div>
        <PageTabs tabs={tabs} defaultValue="payment-center">
          <PageTabPanel value="payment-center">
            <PaymentCenterPage />
          </PageTabPanel>
          <PageTabPanel value="payment-accounts">
            <PaymentAccountsPage />
          </PageTabPanel>
          <PageTabPanel value="past-transactions">
            <PastTransactionsPage />
          </PageTabPanel>
        </PageTabs>
      </main>
    </div>
  );
}
